import { Text, Card, Flex, Badge } from "@radix-ui/themes";

export function LiveConnectionsCard({ metric }) {
  return (
    <Card style={{ display: "flex", padding: "var(--space-4)", flexDirection: "column", justifyContent: "space-between",
        alignItems: "flex-start", flex: "1 0 0", alignSelf: "stretch", height: "100%", background: "var(--blue-a3)",
        "--card-background-color": "var(--blue-2)" }}>
      {/* Top section */}
      <Flex direction="column" style={{ alignSelf: "stretch", height: "100%", justifyContent: "space-between" }}>
        {/* Header with title and badge */}
        <Flex display="flex" align="center" justify="between" style={{ alignSelf: "stretch" }}>
          <Text gap="2" size="2" weight="medium" style={{ color: "var(--blue-12)", alignItems: "center" }}>
            Connections
          </Text>
          <Badge variant="soft" size="1">Live</Badge>
        </Flex>

        {/* Bottom section with metric */}
        <Flex style={{ alignSelf: "stretch" }}>
          <Text size="6" weight="bold" color="blue">{metric}</Text>
        </Flex>
      </Flex>
    </Card>
  );
}
